/* Draft-only delivery-field validation. Checkout-level enforcement is separate. */
(() => {
  if (window.FNVDelivery) return;
  const configNode = document.querySelector('[data-delivery-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.messages;
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;
  let dirty = false;
  const scope = JSON.parse(document.querySelector('[data-delivery-scope]')?.textContent || '{}');
  const iso = date => date.toISOString().slice(0, 10);
  function limits() {
    const today = new Intl.DateTimeFormat('en-CA', {timeZone: config.timeZone, year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const value = key => Number(today.find(p => p.type === key).value);
    const start = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    const min = new Date(start); min.setUTCDate(min.getUTCDate() + 1);
    const max = new Date(start); max.setUTCMonth(max.getUTCMonth() + 2, 1);
    max.setUTCDate(Math.min(start.getUTCDate(), new Date(Date.UTC(max.getUTCFullYear(), max.getUTCMonth() + 1, 0)).getUTCDate()));
    return {min: iso(min), max: iso(max)};
  }
  function normalize(value) {
    value = String(value || '').trim();
    let match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (match) {
      const date = new Date(Date.UTC(+match[1], +match[2]-1, +match[3]));
      return iso(date) === value ? value : '';
    }
    match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
    if (!match) return '';
    const date = new Date(Date.UTC(+match[3], +match[1]-1, +match[2]));
    return date.getUTCFullYear() === +match[3] && date.getUTCMonth()+1 === +match[1] && date.getUTCDate() === +match[2] ? iso(date) : '';
  }
  function validDate(value) {
    const date = normalize(value); const range = limits();
    return !!date && date >= range.min && date <= range.max && new Date(date+'T12:00:00Z').getUTCDay() !== 0;
  }
  function show(container, message, field) {
    const error = container?.querySelector('[data-delivery-error]');
    if (error) {error.textContent = message; error.hidden = !message;}
    if (message) { (field || error)?.focus(); (field || error)?.scrollIntoView({block:'center',behavior:'smooth'}); }
  }
  async function request(path, body) {
    const response = await fetch(root + path, {method: body ? 'POST':'GET', credentials:'same-origin', cache:'no-store', headers:body ? {'Content-Type':'application/json'}:{}, body:body ? JSON.stringify(body):undefined});
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error(text.network);
    return data;
  }
  function arrangements(cart) {
    return cart.items.filter(item => {
      const known = scope[String(item.product_id)];
      if (typeof known !== 'boolean') throw new Error(text.refresh);
      return known;
    });
  }
  function cartValid(cart) {
    const items = arrangements(cart);
    if (!items.length) return true;
    const dates = items.map(item => normalize(item.properties?.['Delivery Date']));
    if (dates.some(date => !validDate(date))) throw new Error(text.date);
    if (new Set(dates).size !== 1) throw new Error(text.mismatch);
    if (items.some(item => !String(item.properties?.['Card Message'] || '').trim())) throw new Error(text.message);
    return true;
  }
  async function validateProduct(form) {
    const container = form.querySelector('[data-delivery-product]');
    if (!container) return true;
    const dateField = container.querySelector('[name="properties[Delivery Date]"]');
    const messageField = container.querySelector('[name="properties[Card Message]"]');
    show(container, '');
    if (!validDate(dateField.value)) {show(container,text.date,dateField);return false;}
    if (!messageField.value.trim()) {show(container,text.message,messageField);return false;}
    try {
      const cart = await request('cart.js');
      cartValid(cart);
      const existing = arrangements(cart);
      if (existing.length && normalize(existing[0].properties['Delivery Date']) !== normalize(dateField.value)) {
        show(container,text.mismatch,dateField);return false;
      }
      dateField.value = normalize(dateField.value);
      return true;
    } catch (error) {show(container,error.message || text.network);return false;}
  }
  async function saveCart(container) {
    if (busy) return;
    const dateField = container.querySelector('[data-order-delivery-date]');
    if (!validDate(dateField.value)) {show(container,text.date,dateField);return;}
    const rows = Array.from(container.querySelectorAll('[data-delivery-line]'));
    const blank = rows.find(row => !row.querySelector('[data-card-message]').value.trim());
    if (blank) {show(container,text.message,blank.querySelector('[data-card-message]'));return;}
    busy = true;
    const button = container.querySelector('[data-save-delivery]'); button.disabled = true;
    show(container,'');
    try {
      let cart = await request('cart.js');
      const items = arrangements(cart);
      if (items.length !== rows.length || items.some(item => !rows.some(row => row.dataset.key === item.key))) throw new Error(text.refresh);
      for (const row of rows) {
        const item = cart.items.find(item => item.key === row.dataset.key);
        if (!item) throw new Error(text.refresh);
        const properties = {...(item.properties || {}), 'Delivery Date': normalize(dateField.value), 'Card Message':row.querySelector('[data-card-message]').value, 'Special Instructions':row.querySelector('[data-special-instructions]').value};
        cart = await request('cart/change.js',{id:item.key,properties});
      }
      cart = await request('cart.js'); cartValid(cart);
      // Preserve other cart attributes; mirror the single date for order-level visibility.
      await request('cart/update.js',{attributes:{date:normalize(dateField.value)}});
      dirty = false;
      window.location.reload();
    } catch(error) {
      // Earlier changes may have succeeded. Reload to reconcile keys before retrying.
      show(container,(error.message || text.network)+' '+text.refresh);
    } finally {busy=false;button.disabled=false;}
  }
  function initialize() {
    const range = limits();
    document.querySelectorAll('[data-delivery-product] input[type="date"], [data-order-delivery-date]').forEach(input => {
      input.min=range.min;input.max=range.max;
      if (window.jQuery?.fn.datepicker) {
        input.type='text'; input.placeholder='YYYY-MM-DD';
        window.jQuery(input).datepicker({dateFormat:'yy-mm-dd',minDate:new Date(range.min+'T12:00:00'),maxDate:new Date(range.max+'T12:00:00'),beforeShowDay:date=>[date.getDay()!==0],onSelect:()=>input.dispatchEvent(new Event('input',{bubbles:true}))});
      }
      input.addEventListener('change',()=>{
        const container=input.closest('[data-delivery-product], [data-delivery-cart]');
        if(input.value && !validDate(input.value))show(container,text.date);else show(container,'');
      });
    });
    document.querySelectorAll('[data-delivery-checkout]').forEach(button=>{button.disabled=false;});
    const container = document.querySelector('[data-delivery-cart]');
    if (container) {
      if (!container.querySelector('[data-delivery-line]')) {container.hidden=true;return;}
      container.addEventListener('input',()=>{dirty=true;});
      container.querySelector('[data-save-delivery]').addEventListener('click',()=>saveCart(container));
      request('cart.js').then(cart=>{
        const dates=arrangements(cart).map(item=>normalize(item.properties?.['Delivery Date']));
        if (dates.length && dates.every(date=>date===dates[0]) && validDate(dates[0])) container.querySelector('[data-order-delivery-date]').value=dates[0];
      }).catch(error=>show(container,error.message || text.network));
    } else {
      request('cart.js').then(cart=>{
        const items=arrangements(cart);
        if (items.length) document.querySelectorAll('[data-delivery-product] input[type="date"]').forEach(input=>{if(!input.value)input.value=normalize(items[0].properties?.['Delivery Date']);});
      }).catch(()=>{});
    }
  }
  window.FNVDelivery = {validateProduct,validDate,normalize,canUpdateQuantity:()=>{
    if(busy || dirty){show(document.querySelector('[data-delivery-cart]'),text.save);return false;}return true;
  }};
  // Capture submit paths that skip the full product form, without changing settings.
  document.addEventListener('submit',event=>{
    const form=event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.action.includes('/cart/add') && !form.querySelector('[data-delivery-product]') && form.closest('sht-prd-qck-vw-frm')) {
      event.preventDefault();event.stopImmediatePropagation();window.location.assign(root+'cart');return;
    }
    const checkout = event.submitter?.name==='checkout' || (form.id==='cartForm' && !event.submitter);
    if (!checkout) return;
    event.preventDefault();event.stopImmediatePropagation();
    const container=document.querySelector('[data-delivery-cart]');
    if(!container){window.location.assign(root+'cart');return;}
    if(busy || dirty){show(container,text.save);return;}
    if(window.FNVDeliveryChecking) return;
    window.FNVDeliveryChecking=true;
    request('cart.js').then(async cart=>{
      cartValid(cart);
      const items=arrangements(cart);
      const update={};
      if(items.length)update.attributes={date:normalize(items[0].properties['Delivery Date'])};
      const note=document.querySelector('#cartNote');if(note)update.note=note.value;
      if(Object.keys(update).length)await request('cart/update.js',update);
      window.location.assign(root+'checkout');
    }).catch(error=>show(container,error.message || text.network)).finally(()=>{window.FNVDeliveryChecking=false;});
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
